import { render, staticRenderFns } from "./InAppOrdersView.vue?vue&type=template&id=23d4ead4&"
import script from "./InAppOrdersView.vue?vue&type=script&lang=js&"
export * from "./InAppOrdersView.vue?vue&type=script&lang=js&"
import style0 from "./InAppOrdersView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports